import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, SimpleChange, OnChanges } from '@angular/core';
import { IEpSearchBoxModel, EpSearchBoxComponent, EpEventService, EpShellService, EpButtonStyle, EpButtonSize } from '@epicor/kinetic';
import { CustomEvents, EpBtCommunicationService, SearchPageNames } from 'ep-bt-controls';
import { EpbtFaRightSideBarComponent } from '../epbt-fa-right-side-bar/epbt-fa-right-side-bar.component';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-search',
  templateUrl: './epbt-fa-customer-search.component.html',
  styleUrls: ['./epbt-fa-customer-search.component.scss']
})
export class EpbtFaCustomerSearchComponent implements OnInit, OnChanges {

  private _searchString: string;

  @Input() index;
  @Input() pageName;
  @Input() placeholder = '';
  @Input() selectedSearchString = '';
  @Input() filterFlag = false;
  @Input() sortFlag = false;
  @Input() fromDashbard = false;
  @Input() disabled = false;
  searchValue: string;
  isReady = true;
  @Output() searchStringChange = new EventEmitter<any>();
  @Output() onEnterClick: EventEmitter<any> = new EventEmitter<any>();
  isFilterActive = false;
  isIndexChange = false;

  model: IEpSearchBoxModel = {
    debounceTime: 50,
    title: '',
    placeholder: this.placeholder,
    disabled: this.disabled,
    onChange: (str: string) => {
      this._searchString = str.trim();
      this.searchStringChange.emit(this._searchString);
    }
  };

  @ViewChild(EpSearchBoxComponent, { static: false }) epSearchBox: EpSearchBoxComponent;
  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  constructor(public epEvent: EpEventService, private epShellService: EpShellService, private filterService: EpbtFaFilterService,
    private sortService: EpbtFaSortService) { }

  ngOnChanges(changes: SimpleChanges) {
    const index: SimpleChange = changes.index;
    if (index && index.currentValue != index.previousValue) {
      this.epSearchBox.clear();
    }

    const placeholder: SimpleChange = changes.placeholder;
    if (placeholder) {
      this.model.placeholder = placeholder.currentValue;
    }

    const disabled: SimpleChange = changes.disabled;
    if (disabled) {
      this.model.disabled = disabled.currentValue;
    }
  }

  ngOnInit() {
    this.model.placeholder = this.placeholder;
    this.updateFilterValue(this.pageName, this.fromDashbard);
    this.displaySearchValue();
  }

  updateSearchValue(searchValue) {
    this.isReady = false;
    setTimeout(() => {
      this.model.searchValue = searchValue;
      this._searchString = searchValue;
      this.model.autoFocus = true;
      this.isReady = true;
    }, 300);
  }

  updateFilterValue(pageName, fromDashboard) {
    this.isFilterActive = this.filterService.isFilterApplied(pageName, fromDashboard);
  }

  displaySearchValue() {
    switch (this.pageName) {
      case SearchPageNames.CustomerSearch:
      case SearchPageNames.ProductSearch:
      case SearchPageNames.SuppliersSearch:
      case SearchPageNames.CustomerAddressSearch:
      case SearchPageNames.DashboardContactSearch:
      case SearchPageNames.CustomerOrders:
      case SearchPageNames.CustomerNotepad:
      case SearchPageNames.DashboardNotepadSearch:
      case SearchPageNames.CustomerProductsPurchased:
      case SearchPageNames.CustomerOpportunity:
      case SearchPageNames.DashboardOpportunitySearch:
      case SearchPageNames.CustomerQuotes:
      case SearchPageNames.CustomerTempOrders:
      case SearchPageNames.CustomerCredit:
      case SearchPageNames.CustomerInvoices:
      case SearchPageNames.CustomerStatements:
      case SearchPageNames.DashboardStockTranferSearch:
      case SearchPageNames.CustomerCallOffOrders:
      case SearchPageNames.DashboardPurchaseOrderSearch:
      case SearchPageNames.DashboardWorkOrderSearch:
      case SearchPageNames.CustomerContactSearch:
        this.model.searchValue = this.selectedSearchString;
        this._searchString = this.selectedSearchString;
        break;
    }
  }

  onSearchCustomer() {
    this.sortService.isFromSorting = false;
    switch (this.pageName) {
      case SearchPageNames.SuppliersSearch:
        this.epEvent.broadcast(CustomEvents.SuppliersSearch, this._searchString);
        break;
      case SearchPageNames.CustomerAddressSearch:
        this.epEvent.broadcast(CustomEvents.CustomerAddressSearch, this._searchString);
        break;
      case SearchPageNames.DashboardContactSearch:
        this.epEvent.broadcast(CustomEvents.DashboardContactSearch, this._searchString);
        break;
      case SearchPageNames.CustomerNotepad:
        this.epEvent.broadcast(CustomEvents.CustomerNotepadSearch, this._searchString);
        break;
      case SearchPageNames.DashboardNotepadSearch:
        this.epEvent.broadcast(CustomEvents.NotepadDashboardSearch, this._searchString);
        break;
      case SearchPageNames.CustomerProductsPurchased:
        this.epEvent.broadcast(CustomEvents.CustomerProductsPurchasedSearch, this._searchString);
        break;
      case SearchPageNames.DashboardOpportunitySearch:
        this.epEvent.broadcast(CustomEvents.DashboardOpportunitySearch, this._searchString);
        break;
      case SearchPageNames.CustomerSearch:
        this.epEvent.broadcast(CustomEvents.CustomerSearch, this._searchString);
        break;
      case SearchPageNames.CustomerDetailsSearch:
        // this.epEvent.broadcast(CustomEvents.CustomerDetailSearch, this._searchString);
        this.onEnterClick.emit();
        break;
      case SearchPageNames.ProductSearch:
        this.epEvent.broadcast(CustomEvents.ProductSearch, this._searchString);
        break;
      case SearchPageNames.ProductDetailsSearch:
        this.epEvent.broadcast(CustomEvents.ProductDetailSearch, this._searchString);
        break;
      case SearchPageNames.BinLocationProductSearch:
        this.epEvent.broadcast(CustomEvents.BinLocationProductSearch, this._searchString);
        this.onEnterClick.emit();
        break;
      case SearchPageNames.DashboardAddressSearch:
        this.epEvent.broadcast(CustomEvents.DashboardAddressSearch, this._searchString);
        break;
      case SearchPageNames.CustomerInfoSearch:
        this.epEvent.broadcast(CustomEvents.CustomerInfoSearch, this._searchString);
        break;
      case SearchPageNames.CustomerFinancialSearch:
        this.epEvent.broadcast(CustomEvents.CustomerFinancialSearch, this._searchString);
        break;
      case SearchPageNames.CustomerJobBalanceSearch:
        this.epEvent.broadcast(CustomEvents.CustomerJobBalanceSearch, this._searchString);
        break;
      case SearchPageNames.CustomerAttachmentsSearch:
        this.epEvent.broadcast(CustomEvents.CustomerAttachmentsSearch, this._searchString);
        break;
      case SearchPageNames.DashboardDocumentsSearch:
        this.epEvent.broadcast(CustomEvents.DashboardDocumentSearch, this._searchString);
        break;
      case SearchPageNames.CustomerContactSearch:
        this.epEvent.broadcast(CustomEvents.CustomerContactSearch, this._searchString);
        break;
      case SearchPageNames.CustomerOrders:
      case SearchPageNames.CustomerOpportunity:
      case SearchPageNames.CustomerQuotes:
      case SearchPageNames.CustomerTempOrders:
      case SearchPageNames.CustomerCredit:
      case SearchPageNames.CustomerInvoices:
      case SearchPageNames.CustomerStatements:
      case SearchPageNames.CustomerCallOffOrders:
      case SearchPageNames.DashboardStockTranferSearch:
      case SearchPageNames.DashboardPurchaseOrderSearch:
      case SearchPageNames.DashboardWorkOrderSearch:
        // this.epEvent.broadcast(CustomEvents.CustomerDocumentSearch, this._searchString);
        this.onEnterClick.emit();
        break;
      case SearchPageNames.QuickOrderCustomer:
        this.epEvent.broadcast(CustomEvents.QuickOrderCustomer, this._searchString);
        break;
      case SearchPageNames.QuickOrderProduct:
        this.epEvent.broadcast(CustomEvents.QuickOrderProduct, this._searchString);
        this.onEnterClick.emit();
        break;
      case SearchPageNames.QuickTransferProductSearch:
      case SearchPageNames.QuickPurchaseProductSearch:
      case SearchPageNames.CompetitorProductSearch:
      case SearchPageNames.LabelsProductSearch:
        this.onEnterClick.emit();
        break;
    }
  }

  onFilterOrSort() {
    const context: any = {
      width: 330
    };
    this.filterService.pageName = this.pageName;
    this.sortService.currentPageName = this.pageName;
    this.sortService.sortFlag = this.sortFlag;
    this.filterService.filterFlag = this.filterFlag;
    this.epShellService.showSlidePanel(<any>EpbtFaRightSideBarComponent, context);
  }

  showFocus() {
    this.isReady = false;
    setTimeout(() => {
      this.model.autoFocus = true;
      this.isReady = true;
    }, 100);
  }
}
